export default function parseUsername(username) {
    if (username.startsWith('utauth_')) {
        return username.split('utauth_').join('')
    } 
    return username
}